import React, { useEffect, useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PhoneNumber from "libphonenumber-js";
import AuthContext from "../../../context/auth/AuthContext";
import backicon from "../../../assets/img/back.png";
import logouticon from "../../../assets/img/logout.png";
import useTranslator from "../../../hooks/useTranslator";
import { Button, Modal } from "react-bootstrap";
import greentick from "../../../assets/img/greentick.png";
import cross from "../../../assets/img/cross-short.png";
import { convertCurrencyFormat, haveValue } from "../../../helper/common";
import { useSnackbar } from "material-ui-snackbar-provider";
import { VscEye, VscEyeClosed } from "react-icons/vsc";
import { toast } from "react-toastify";
import constants from "../../../Utils/constants";
import linkedIn from "../../../assets/img/linkedIn.svg";
import axiosInstance from "../../../services/authWrapper";
const TenantProfile = () => {
  const { _t } = useTranslator();

  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { user, logout, userType, changePassword } = authContext;
  const snackbar = useSnackbar();

  const [countryCode, setCountryCode] = useState("");
  const [changePasswordModal, setChangePasswordModal] = useState(false);

  const defaultPassData = {
    // old_password: "",
    new_password: "",
    confirm_password: "",
    type: localStorage.getItem("usertype"),
  };
  const defaultShowPass = {
    // old_password: false,
    new_password: false,
    confirm_password: false,
  };
  const [showPassword, setShowPassword] = useState(defaultShowPass);
  const [passData, setPassData] = useState(defaultPassData);
  const [pwdErrorMsg, setpwdErrorMsg] = useState("");

  useEffect(() => {
    if (localStorage.getItem("usertype") !== "tenant") navigate("/");
    if (user?.country_code) {
      setCountryCode(user?.country_code);
    }
  }, []);

  const handlePassChange = (e) => {
    setpwdErrorMsg("");
    setPassData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const editProfile = () => {
    navigate(`/edit-profile/${userType}`);
  };
  const editFinancial = () => {
    navigate(`/edit-profile/financial`);
  };

  const checkKyc = () => {
    // let kyc_nationality = userKycInfo?.onfido_doc_data?.nationality.toLowerCase()
    let kyc_done = user?.onfido_kyc_success;

    if (kyc_done) {
      // return kyc_nationality;
      return <img src={greentick} alt="" />;
    } else {
      return <img src={cross} alt="" />;
    }
  };
  const [tabOpen, setTabOpen] = useState("Personal");

  const changeTab = (buttonText) => {
    if (buttonText == "Personal") {
      setTabOpen("Personal");
    }
    if (buttonText == "Financial") {
      setTabOpen("Financial");
    }
  };

  const getEmploymentStatus = () => {
    if (user?.employment_status == constants.employed) {
      return _t("employed");
    }
    if (user?.employment_status == constants.self_employed) {
      return _t("selfEmployed");
    }
    if (user?.employment_status == constants.student) {
      return _t("student");
    }
    if (user?.employment_status == constants.unemployed) {
      return _t("unemployed");
    }
    if (user?.employment_status == constants.retired) {
      return _t("retired");
    }
    if (user?.employment_status == constants.public_servant) {
      return _t("publicServant");
    }
  };

  const strongPassword = new RegExp(
    "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})"
  );
  const handleChangePassword = async (e) => {
    e.preventDefault();
    console.log(passData);
    if (
      // passData.old_password === "" ||
      passData.new_password === "" ||
      passData.confirm_password === ""
    ) {
      setpwdErrorMsg(_t("pleaseEnterAllFields"));
    } else if (passData.new_password !== passData.confirm_password) {
      setpwdErrorMsg(_t("passwordNotMatches"));
    } else if (!strongPassword.test(passData.new_password)) {
      setpwdErrorMsg(
        _t("pleaseIncludeUppercaseLowercaseAndSpecialCharactersInYourPassword")
      );
    } else {
      changePassword(passData, user?._id)
        .then((res) => {
          console.log(res, "CHECK TEH VAL HERE");
          if (res) {
            toast.success(_t("passwordChanged"));
            setChangePasswordModal(false);
            setPassData(defaultPassData);
            setShowPassword(defaultShowPass);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleShowPassword = async (type) => {
    setShowPassword((prev) => ({ ...prev, [type]: !prev[type] }));
  };

  const [sampleNumber, setSampleNumber] = useState("");
  const handleTest = async () => {
    const res = await axiosInstance.post(
      `${process.env.REACT_APP_SERVER_URL}/users/send/template`,
      {
        phone_number: sampleNumber,
        content_id: "HX1bc7825d3071d5950e8776b7e610523e",
      },
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );

    console.log(res);
  };

  return (
    <>
      {/* <input type="text" onChange={(e) => setSampleNumber(e.target.value)} />
      <button onClick={handleTest}>Submit</button> */}
      {/* <div className='margin-div'> </div> */}
      <div className="tabs-box-pattern">
        <div className="tabs-item d-block">
          <div className="row">
            <div className="header-edit text-center space-custom d-flex items-center justify-content-between">
              <div>
                <Link to="/">
                  <img src={backicon} alt="" />
                </Link>
              </div>
              <h3>{_t("profile")}</h3>
              <p></p>
              {/* <Link onClick={logout} className="logout"><img src={logouticon} /></Link> */}
            </div>
            <div className="admin-name2">
              <Link>
                {user?.fname && user?.fname.charAt(0).toUpperCase()}
                {user?.lname && user?.lname.charAt(0).toUpperCase()}
              </Link>
            </div>

            <h4 className="text-center mt-3 mb-5 user-name">
              {user?.fname} {user?.lname}
            </h4>
          </div>
          <div className="row d-block m-md-auto ">
            <div className="finacial tab-with-editbtn">
              <ul
                className="nav nav-pills  edit-tabs"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    onClick={(e) => changeTab("Personal")}
                    className="nav-link active"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    {_t("personal")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    onClick={(e) => changeTab("Financial")}
                    className="nav-link"
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                  >
                    {_t("financial")}
                  </button>
                </li>
              </ul>
              <div className="editbar">
                {/* <button className="btn-fill2" onClick={logout}  >Logout</button> */}
                {tabOpen == "Personal" && (
                  <button
                    className="btn-fill-border change-password-btn"
                    onClick={(e) => setChangePasswordModal(true)}
                  >
                    {/* --------------------new responsive css (3brain)-----------------  */}
                    {/* <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg"> */}
                    <svg
                      width="1.34vw"
                      height="1.19vw"
                      viewBox="0 0 21 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.10872 5.30803L5.70272 4.82003C5.82833 4.78162 5.96028 4.76832 6.09103 4.7809C6.22177 4.79348 6.34876 4.83169 6.46474 4.89335C6.58072 4.95501 6.68342 5.03891 6.76698 5.14026C6.85054 5.24161 6.91331 5.35842 6.95172 5.48403C6.99014 5.60964 7.00343 5.74158 6.99085 5.87233C6.97827 6.00308 6.94006 6.13007 6.8784 6.24605C6.81674 6.36203 6.73284 6.46473 6.6315 6.54829C6.53015 6.63184 6.41333 6.69462 6.28772 6.73303L2.46272 7.90303C2.33705 7.94145 2.20504 7.95473 2.07423 7.94209C1.94342 7.92946 1.81639 7.89117 1.70039 7.82941C1.58439 7.76765 1.4817 7.68363 1.3982 7.58216C1.31469 7.48068 1.25201 7.36375 1.21372 7.23803L0.0437243 3.41303C0.00531264 3.28742 -0.00798228 3.15547 0.00459861 3.02473C0.0171795 2.89398 0.0553898 2.76699 0.117048 2.65101C0.178706 2.53503 0.262604 2.43233 0.363953 2.34877C0.465301 2.26522 0.582115 2.20244 0.707724 2.16403C0.961404 2.08645 1.23551 2.11283 1.46974 2.23735C1.70398 2.36188 1.87915 2.57435 1.95672 2.82803L2.39672 4.26903C4.80472 0.560029 9.58172 -1.03497 13.8227 0.703029C15.091 1.22289 16.23 2.01437 17.1595 3.02179C18.089 4.0292 18.7864 5.22807 19.2027 6.53403C19.2454 6.65983 19.2626 6.79288 19.2533 6.9254C19.244 7.05792 19.2083 7.18725 19.1485 7.30585C19.0886 7.42444 19.0057 7.52992 18.9046 7.61613C18.8036 7.70234 18.6863 7.76754 18.5598 7.80793C18.4332 7.84832 18.2999 7.86309 18.1676 7.85138C18.0352 7.83967 17.9066 7.80171 17.7891 7.73971C17.6716 7.67772 17.5676 7.59294 17.4832 7.49032C17.3989 7.3877 17.3358 7.2693 17.2977 7.14203C16.8753 5.8154 16.0862 4.63531 15.0216 3.73803C13.957 2.84074 12.6604 2.26285 11.2814 2.07108C9.90239 1.87931 8.49727 2.08147 7.22827 2.65424C5.95927 3.22701 4.87714 4.14701 4.10872 5.30803ZM16.4357 13.503L14.6607 13.946C14.5322 13.9813 14.3979 13.9905 14.2658 13.9731C14.1337 13.9557 14.0063 13.9121 13.8913 13.8448C13.7763 13.7775 13.6759 13.6879 13.5959 13.5812C13.516 13.4746 13.4583 13.353 13.426 13.2237C13.3937 13.0944 13.3877 12.9599 13.4081 12.8282C13.4285 12.6966 13.4751 12.5703 13.545 12.4568C13.615 12.3434 13.7069 12.2451 13.8154 12.1677C13.9238 12.0902 14.0467 12.0353 14.1767 12.006L17.8197 11.097C18.0095 11.0067 18.223 10.9787 18.4297 11.017C18.6289 11.0432 18.8155 11.1288 18.9653 11.2626C19.1152 11.3963 19.2212 11.5721 19.2697 11.767L20.2377 15.647C20.2951 15.9019 20.2504 16.169 20.1133 16.3914C19.9763 16.6137 19.7576 16.7736 19.5042 16.8368C19.2507 16.9001 18.9826 16.8616 18.7572 16.7297C18.5317 16.5978 18.3668 16.3829 18.2977 16.131L17.9677 14.809C17.0049 16.1946 15.6862 17.2948 14.1505 17.9939C12.6149 18.6929 10.9191 18.9648 9.24189 18.7809C7.56468 18.597 5.96809 17.9642 4.62033 16.9492C3.27257 15.9341 2.22353 14.5743 1.58372 13.013L1.32372 12.379C1.27395 12.2575 1.24861 12.1273 1.24914 11.996C1.24967 11.8647 1.27606 11.7347 1.3268 11.6136C1.37755 11.4925 1.45166 11.3825 1.5449 11.29C1.63814 11.1975 1.74869 11.1243 1.87022 11.0745C2.11568 10.974 2.39102 10.9751 2.63566 11.0776C2.75679 11.1284 2.86674 11.2025 2.95924 11.2957C3.05173 11.3889 3.12495 11.4995 3.17472 11.621L3.43472 12.254C3.94447 13.4979 4.78422 14.5789 5.86334 15.3804C6.94246 16.1819 8.21997 16.6735 9.55803 16.8022C10.8961 16.9308 12.2439 16.6916 13.4559 16.1104C14.668 15.5291 15.6983 14.6269 16.4357 13.503Z"
                        fill="#EF7833"
                      />
                    </svg>
                    {_t("changePassword")}
                  </button>
                )}
                <button
                  className="btn-fill-border edit-btn"
                  onClick={tabOpen == "Personal" ? editProfile : editFinancial}
                >
                  {_t("editProfile")}
                </button>
              </div>
            </div>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
              >
                <h3 className="Property">{_t("basic")}</h3>
                <div className="edit-profile row">
                  {haveValue(user?.dni_nie) ? (
                    <div className="edit-line col-6">
                      <h4>{_t("dniNie")}:</h4>
                      <h3>{user?.dni_nie}</h3>
                    </div>
                  ) : (
                    <div className="edit-line col-6">
                      <h4>{_t("passportID")}:</h4>
                      <h3>{user?.passport_id}</h3>
                    </div>
                  )}
                  <div className="edit-line col-6">
                    <h4>{_t("digitalIdentityVerification")}:</h4>
                    <h3>
                      {user?.onfido_kyc_success
                        ? _t("completed")
                        : _t("notCompleted")}{" "}
                      <span>{checkKyc()}</span>{" "}
                    </h3>
                  </div>
                  <div className="edit-line col-6">
                    <h4>{_t("nationality")}:</h4>
                    <h3>{_t(user?.nationality, "", "fixed")}</h3>
                  </div>
                  <div className="edit-line col-6">
                    <h4>{_t("phoneNumber")}:</h4>
                    <h3>{user?.phone_number}</h3>
                  </div>
                  <div className="edit-line col-6">
                    <h4>{_t("email")}:</h4>
                    <h3>{user?.email}</h3>
                  </div>
                  <div className="edit-line col-6">
                    <h4>{_t("linkedInProfile")}:</h4>
                    {user?.linkedin_profile && (
                      <a
                        href={user.linkedin_profile}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={linkedIn} alt="" />
                      </a>
                    )}
                  </div>
                </div>
                <h3 className="Property mt-3">{_t("educationalEmployment")}</h3>
                <div className="edit-profile row">
                  <div className="edit-line col-6">
                    <h4>{_t("employmentStatus")}:</h4>
                    <h3>{getEmploymentStatus()}</h3>
                  </div>
                  {[constants.public_servant, constants.employed].includes(
                    user?.employment_status ?? ""
                  ) && (
                    <div className="edit-line col-6">
                      <h4>{_t("employmentCategory")}:</h4>
                      <h3>{_t(user?.employment_category)}</h3>
                    </div>
                  )}
                  {user?.employment_status === constants.self_employed && (
                    <>
                      <div className="edit-line col-6">
                        <h4>{_t("employmentType")}:</h4>
                        <h3>
                          {user?.is_freelancer
                            ? _t("freelancer")
                            : _t("ownACompany")}
                        </h3>
                      </div>
                      {user?.is_freelancer == false && (
                        <div className="edit-line col-6">
                          <h4>{_t("companyName")}:</h4>
                          <h3>{user?.name_of_company}</h3>
                        </div>
                      )}
                    </>
                  )}
                  {user?.employment_status === constants.employed && (
                    <>
                      <div className="edit-line col-6">
                        <h4>{_t("position")}:</h4>
                        <h3>{user?.position}</h3>
                      </div>
                      <div className="edit-line col-6">
                        <h4>{_t("nameOfEmployerCompany")}:</h4>
                        <h3>{user?.name_of_company}</h3>
                      </div>
                    </>
                  )}
                  <div className="edit-line col-6">
                    <h4>{_t("annualIncome")}:</h4>
                    <h3>
                      {convertCurrencyFormat(user?.current_annual_income)}
                    </h3>
                  </div>
                  {user?.employment_status === constants.student && (
                    <>
                      <div className="col-12">
                        <h3 className="heading-student-edu">
                          {_t("currentEducationDetails")}
                        </h3>
                      </div>

                      <div className="edit-line col-6">
                        <h4>{_t("educationLevel")}:</h4>
                        <h3>{_t(user?.current_course, "", "fixed")}</h3>
                      </div>
                      <div className="edit-line col-6">
                        <h4>{_t("institutionName")}:</h4>
                        <h3>{user?.name_of_current_university}</h3>
                      </div>
                      <div className="edit-line col-6">
                        <h4>{_t("institutionEmail")}:</h4>
                        <h3>{user?.email_of_university}</h3>
                      </div>
                      <div className="edit-line col-6">
                        <h4>{_t("expectedCourseEndDate")}:</h4>
                        <h3>{user?.university_end_date}</h3>
                      </div>
                      <div className="col-12">
                        <h3 className="heading-student-edu">
                          {_t("highestEducationDetails")}
                        </h3>
                      </div>
                    </>
                  )}
                  <div className="edit-line col-6">
                    <h4>
                      {user?.employment_status !== constants.student
                        ? _t("highestEducationLevel")
                        : _t("educationLevel")}
                      :
                    </h4>
                    <h3>{_t(user?.type_of_student, "", "fixed")}</h3>
                  </div>
                  <div className="edit-line col-6">
                    <h4>{_t("institutionName")}:</h4>
                    <h3>{user?.name_of_university}</h3>
                  </div>
                </div>
                <h3 className="Property mt-3">{_t("rentingDetails")}</h3>
                <div className="edit-profile row">
                  <div className="edit-line col-6">
                    <h4>{_t("timeLivedInSpain")}:</h4>
                    <h3>{`${user?.years_of_living_in_country} ${user?.duration_type}`}</h3>
                  </div>
                  <div className="edit-line col-6">
                    <h4>{_t("haveYouRentedBefore")}:</h4>
                    <h3>{_t(user?.rented_locally_before)}</h3>
                  </div>
                  <div className="edit-line col-6">
                    <h4>{_t("emailOfPreviousLandlord")}:</h4>
                    <h3>{user?.email_previous_landlord}</h3>
                  </div>
                  <div className="edit-line col-6">
                    <h4>{_t("doYouHaveASharer")}:</h4>
                    <h3>{_t(user?.have_sharer)} </h3>
                  </div>
                  {user?.have_sharer == "yes" &&
                    haveValue(user?.sharers) &&
                    user?.sharers.length > 0 &&
                    user?.sharers.map((sharer, index) => (
                      <>
                        <label>
                          {_t("flatmate")} {index + 1}
                        </label>
                        <div className="edit-line col-6">
                          <h4>{_t("nameOfFlatmate")}:</h4>
                          <h3>{sharer?.name}</h3>
                        </div>
                        <div className="edit-line col-6">
                          <h4>{_t("emailOfFlatmate")}:</h4>
                          <h3>{sharer?.email}</h3>
                        </div>
                      </>
                    ))}
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="pills-profile"
                role="tabpanel"
                aria-labelledby="pills-profile-tab"
              >
                <h3 className="Property">{_t("bankDetails")}</h3>
                <div className="edit-profile row">
                  <div className="edit-line col-6">
                    <h4>{_t("iban")}:</h4>
                    <h3>
                      {
                        user?.kyc_details?.userDataByProvider[0]?.accounts[0]
                          ?.iban
                      }
                    </h3>
                  </div>
                  <div className="edit-line col-6">
                    <h4>{_t("currentAnnualIncome")}:</h4>
                    <h3>
                      {convertCurrencyFormat(user?.current_annual_income)}
                    </h3>
                  </div>
                </div>
                {haveValue(user?.gurantor_for) ? (
                  <>
                    <h3 className="Property">{_t("guarantorDetails")}</h3>
                    <div className="edit-profile row">
                      <div className="edit-line col-6">
                        <h4>{_t("guarantorOf")}:</h4>
                        <h3>
                          {user?.gurantor_for?.fname}{" "}
                          {user?.gurantor_for?.lname}
                        </h3>
                      </div>
                      <div className="edit-line col-6">
                        <h4>{_t("nationality")}:</h4>
                        <h3>
                          {_t(user?.gurantor_for?.nationality, "", "fixed")}
                        </h3>
                      </div>
                      <div className="edit-line col-6">
                        <h4>{_t("phoneNumber")}:</h4>
                        <h3>{user?.gurantor_for?.phone_number}</h3>
                      </div>
                      <div className="edit-line col-6">
                        <h4>{_t("email")}:</h4>
                        <h3>{user?.gurantor_for?.email}</h3>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <h3 className="Property">{_t("guarantorDetails")}</h3>
                    <div className="edit-profile row">
                      <div className="edit-line col-6">
                        <h4>{_t("doYouHaveAGuarantor")}:</h4>
                        <h3>
                          {user?.have_gurantor == "true" ||
                          user?.have_gurantor == true
                            ? _t("yes")
                            : _t("no")}
                        </h3>
                      </div>
                      {user?.have_gurantor == "true" ||
                      user?.have_gurantor == true ? (
                        <>
                          <div className="edit-line col-6">
                            <h4>{_t("nameOfGuarantor")}:</h4>
                            <h3>{user?.gurantor_name}</h3>
                          </div>
                          <div className="edit-line col-6">
                            <h4>{_t("emailOfGuarantor")}:</h4>
                            <h3>{user?.gurantor_email}</h3>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={changePasswordModal}
        onHide={(e) => setChangePasswordModal(false)}
        centered
        className="newmodalui"
      >
        <Modal.Header closeButton>
          <Modal.Title>{_t("changePassword")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleChangePassword}>
            <div className="auth-form">
              {/* <div className="forminput row100">
                <label className="forminput">{_t("oldPassword")}</label>
                <div className="input-with-eye">
                  <input
                    type={showPassword?.old_password ? "text" : "password"}
                    name="old_password"
                    placeholder={_t("enterPassword")}
                    onChange={handlePassChange}
                  />
                  {showPassword?.old_password ? (
                    <VscEye
                      className="eye-icons-reset"
                      onClick={(e) => handleShowPassword("old_password")}
                    />
                  ) : (
                    <VscEyeClosed
                      className="eye-icons-reset"
                      onClick={(e) => handleShowPassword("old_password")}
                    />
                  )}
                </div>
              </div> */}
              <div className="forminput row100">
                <label className="forminput">{_t("newPassword")}</label>
                <div className="input-with-eye">
                  <input
                    type={showPassword?.new_password ? "text" : "password"}
                    name="new_password"
                    placeholder={_t("enterPassword")}
                    onChange={handlePassChange}
                  />
                  {showPassword?.new_password ? (
                    <VscEye
                      className="eye-icons-reset"
                      onClick={(e) => handleShowPassword("new_password")}
                    />
                  ) : (
                    <VscEyeClosed
                      className="eye-icons-reset"
                      onClick={(e) => handleShowPassword("new_password")}
                    />
                  )}
                </div>
              </div>
              <div className="forminput row100">
                <label className="forminput">{_t("reEnterNewPassword")}</label>
                <div className="input-with-eye">
                  <input
                    type={showPassword?.confirm_password ? "text" : "password"}
                    name="confirm_password"
                    placeholder={_t("enterPassword")}
                    onChange={handlePassChange}
                  />
                  {showPassword?.confirm_password ? (
                    <VscEye
                      className="eye-icons-reset"
                      onClick={(e) => handleShowPassword("confirm_password")}
                    />
                  ) : (
                    <VscEyeClosed
                      className="eye-icons-reset"
                      onClick={(e) => handleShowPassword("confirm_password")}
                    />
                  )}
                </div>
              </div>
              <div className="btngroup row100">
                {haveValue(pwdErrorMsg) && (
                  <label className="forminput password_error">
                    {pwdErrorMsg}
                  </label>
                )}
                <p className="password_condition font_design">
                  {_t(
                    "passwordMustBeAtleastEightCharactersLongAndContainANumberLowercaseUppercaseAndASpecialCharacter"
                  )}
                </p>
                <button className="btn btnorange" type="submit">
                  {_t("changePassword")}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TenantProfile;
